import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { DIdentidadAuthConfigServicios, RespuestaGenerica, MedioComunicacion, SolicitudOTP } from '@dian/api-identidad-auth-config';
import { ConsumirOTP } from './../../../../resources/to/consumir-otp';
import { OtpService } from './../../../../resources/services/otp.service';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { UtilsService } from './../../../../resources/services/utils.service';

@Component({
  selector: 'app-confirmacion',
  templateUrl: './confirmacion.component.html',
  styleUrls: ['./confirmacion.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ OtpService, UtilsService ]
})
export class ConfirmacionComponent implements OnInit {

	public loading: boolean = false;
	public otp: string = "";	
	public tipoComunicacion: MedioComunicacion;
  public showNotFoundCode = false;
  public showValidCode = false;
  public timer = 60;
	
	private identificacion: string = '';	
  private tieneFirmaElectronica: string = '';
  constructor(
  	private router: Router,
  	private _rest: DIdentidadAuthConfigServicios,
  	private _restOtp: OtpService,
    private utils: UtilsService,
  	private dialog: MatDialog
  ) { }

  ngOnInit() {
  	this.identificacion = localStorage.getItem('identificacion');  
  	this.tipoComunicacion = <MedioComunicacion>JSON.parse(localStorage.getItem('tipo-comunicacion')); 
    const mediosComunicacion = JSON.parse(localStorage.getItem('medios-comunicacion'));
    this.tieneFirmaElectronica = mediosComunicacion.datos.tieneFirmaElectronica;
    this.startTimer(); 
  }

  public consumirOTP() {
    this.loading = true;
    this.showNotFoundCode = false;
    this.showValidCode = false;
 /*    
    const obj = new ConsumirOTP();
    obj.usuario.identificacion = this.identificacion;
    obj.usuario.organizacion = "2";
    obj.otp = this.otp;    */
    
    this._restOtp.getConsultarOtp(this.identificacion, this.otp).subscribe(
      res => {
         localStorage.setItem('otp', this.otp); 
         const fechaActual = new Date();	

        if(res.estado === "DISPONIBLE" && (fechaActual <= new Date(res.vigenteHasta))){
          if(this.tieneFirmaElectronica === "false"){
            this.router.navigate(['/recuperar-cuenta/pass-firma']);
          }else{
            localStorage.setItem('generarFirma', "true"); 
            this.router.navigate(['/recuperar-cuenta/cambiar-pass']);           
          }
        }else if(fechaActual > new Date(res.vigenteHasta)){
          this.showNotFoundCode = true;
        } 
       
     /*    this.router.navigate(['/recuperar-cuenta/cambiar-pass']); */
      },
      error => {      
        if (error.error.codigo == 401) this.showNotFoundCode = true;
        if (error.error.codigo == 404) this.showValidCode = true; 
      	this.loading = false;
       
      },
      () => this.loading = false
    );
  } 

  startTimer() {    
    const intervalCount = setInterval(() => { 
      if (this.timer === 1) {        
        clearInterval(intervalCount);                 
        this.timer = 60;
      } else this.timer--;          
    }, 1000);   
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/confirmacion/confirmacion.component.ts